import script from "./Dropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./Dropdown.vue?vue&type=script&setup=true&lang=js"

import "./Dropdown.vue?vue&type=style&index=0&id=6525b49e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6525b49e"]])

export default __exports__